import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromDeviceSetting from './reducers/device-setting.reducer';
import {EffectsModule} from '@ngrx/effects';
import {DeviceSettingEffects} from './effects/device-setting.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('deviceSetting', fromDeviceSetting.reducer),
    EffectsModule.forFeature([ DeviceSettingEffects ]),
  ]
})
export class DeviceSettingModule { }
